module.exports = __webpack_public_path__ + "static/img/Planos-Enterprise.44bb3d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photoPeople/Planos-Enterprise.png
// module id = /d/F
// module chunks = 1